export const ACCORDION_ICON = {
	open: "ico-chevron-down",
	close: "ico-chevron-up",
};
